module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<style>\n	.width-regulator td:nth-child(1) {\n		width: 30%;\n	}\n\n	.width-regulator td:nth-child(2) {\n		width: 10%;\n	}\n\n	.width-regulator td:nth-child(3) {\n		width: 10%;\n	}\n\n	.width-regulator td:nth-child(4) {\n		width: 10%;\n	}\n\n	.width-regulator td:nth-child(5) {\n		width: 10%;\n	}\n\n	.width-regulator td:nth-child(6) {\n		width: 10%;\n	}\n\n	.width-regulator td:nth-child(7) {\n		width: 10%;\n	}\n\n	.width-regulator td:nth-child(8) {\n		width: 10%;\n	}\n</style>\n\n<table class=\"w100 gl-report__table width-regulator\">\n	<thead>\n	<tr>\n		<td>Организация</td>\n		<td>Гос. номер</td>\n		<td>Модель ТС</td>\n\n		<td>Номер трекера</td>\n		<td>Номер sim</td>\n		<td>Количество дней недоступности</td>\n		<td>Дата последнего сигнала (сервер)</td>\n		<td>Дата последнего сигнала (трекер)</td>\n	</tr>\n	</thead>\n</table>\n\n<div class=\"wh100\">\n	<div class=\"cell__abs_container\">\n		<div class=\"cell__abs overflow-y__auto\">\n\n			<table class=\"w100 gl-striped__table gl-report__table width-regulator\">\n				<tbody>\n				")
    ;  if (data) { 
    ; __append("\n				")
    ;  Util.each(data, function (item) { 
    ; __append("\n				<tr>\n					<td>")
    ; __append(escapeFn( item.organizationalias ))
    ; __append("</td>\n					<td>")
    ; __append(escapeFn( item.vehiclenum ))
    ; __append("</td>\n					<td>")
    ; __append(escapeFn( item.model ))
    ; __append("</td>\n\n					")
    ;  if (item.last) { 
    ; __append("\n					<td>")
    ; __append(escapeFn( item.last.trackernum ))
    ; __append("</td>\n					<td>")
    ; __append(escapeFn( item.last.sim ))
    ; __append("</td>\n					<td>")
    ; __append(escapeFn( item.last.inactivedayscount ))
    ; __append("</td>\n\n					<td>")
    ; __append(escapeFn( Date.fromTZ(item.serverdatetime).format() ))
    ; __append("</td>\n					<td>")
    ; __append(escapeFn( Date.fromTZ(item.trackerdatetime).format() ))
    ; __append("</td>\n					")
    ;  } else { 
    ; __append("\n					<td>-</td>\n					<td>-</td>\n					<td>-</td>\n					<td>-</td>\n					<td>-</td>\n					")
    ;  } 
    ; __append("\n				</tr>\n				")
    ;  }); 
    ; __append("\n				")
    ;  } 
    ; __append("\n				</tbody>\n			</table>\n		</div>\n	</div>\n</div>\n")
  }
  return __output.join("");

}